import React, { useState, useEffect } from 'react';
import styles from '../index.module.css';

const CarouselSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    { title: 'Extensive longitudinal data for', highlight: '25K+ patients' },
    { title: 'ClinicoGenomic data spanning', highlight: 'Southeast Asia, Latin America & Middle East' },
    { title: 'Comprehensive dataset', highlight: 'facilitating New Biomarker discovery, drug design & clinical trials' }
  ];

  // --- CAROUSEL LOGIC ---
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div className={`col-12 col-md-8 ${styles['left-section']}`}>
      <div className={styles['carousel-container']}>
        <div className={styles['carousel-content']}>
          {slides.map((slide, i) => (
            <div
              key={i}
              className={`${styles.slide} ${i === currentSlide ? styles.active :
                  i < currentSlide ? styles.prev : styles.next
                }`}
            >
              <h1 className={styles['slide-title']}>{slide.title}</h1>
              <h1 className={styles['slide-highlight']}>{slide.highlight}</h1>
            </div>
          ))}
        </div>
        <div className={styles['carousel-indicators']}>
          {slides.map((_, i) => (
            <span
              key={i}
              className={`${styles.indicator} ${i === currentSlide ? styles.active : ''}`}
              onClick={() => setCurrentSlide(i)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CarouselSection;
